module.exports = __webpack_public_path__ + "static/media/demo_homepage.fd75b812.png";